export default __webpack_public_path__ + "static/media/MiniaturaPerformance.1cf23b5d.jpg";